import React, { useEffect, useState } from 'react';
import Highlight from 'react-highlight';
import Chart from 'react-apexcharts';
import { Card, CardHeader, CardHeaderBtn, CardBody } from './../../components/card/card.jsx';
import { NavScrollTo } from './../../components/nav-scroll-to/nav-scroll-to.jsx';
import { getChartApexDefaultOptions } from './../../composables/chartOptions.js';

function ChartApex() {
	const [lineChartOptions, setLineChartOptions] = useState(getLineChartOptions());
	const [columnChartOptions, setColumnChartOptions] = useState(getColumnChartOptions());
	const [areaChartOptions, setAreaChartOptions] = useState(getAreaChartOptions());
	const [barChartOptions, setBarChartOptions] = useState(getBarChartOptions());
	const [mixedChartOptions, setMixedChartOptions] = useState(getMixedChartOptions());
	const [candlestickChartOptions, setCandlestickChartOptions] = useState(getCandlestickChartOptions());
	const [bubbleChartOptions, setBubbleChartOptions] = useState(getBubbleChartOptions());
	const [scatterChartOptions, setScatterChartOptions] = useState(getScatterChartOptions());
	const [heatmapChartOptions, setHeatmapChartOptions] = useState(getHeatmapChartOptions());
	const [pieChartOptions, setPieChartOptions] = useState(getPieChartOptions());
	const [radialBarChartOptions, setRadialBarChartOptions] = useState(getRadialBarChartOptions());
	const [radarChartOptions, setRadarChartOptions] = useState(getRadarChartOptions());
	
	const [code1, setCode1] = useState();
	const [code2, setCode2] = useState();
	const [code3, setCode3] = useState();
	const [code4, setCode4] = useState();
	const [code5, setCode5] = useState();
	const [code6, setCode6] = useState();
	const [code7, setCode7] = useState();
	const [code8, setCode8] = useState();
	const [code9, setCode9] = useState();
	const [code10, setCode10] = useState();
	const [code11, setCode11] = useState();
	const [code12, setCode12] = useState();
	
	
	function generateBubbleChartData(baseval, count, yrange) {
		var i = 0;
		var series = [];
		while (i < count) {
			var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;;
			var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
			var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;
			series.push([x, y, z]);
			baseval += 86400000;
			i++;
		}
		return series;
	}
	function generateHeatmapData(count, yrange) {
		var i = 0;
		var series = [];
		while (i < count) {
			var x = 'w' + (i + 1).toString();
			var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
			series.push({ x: x, y: y });
			i++;
		}
		return series;
	}
		
	var lineChartData = [
		{ name: 'High - 2026', data: [28, 29, 33, 36, 32, 32, 33]	}, 
		{ name: 'Low - 2026', data: [12, 11, 14, 18, 17, 13, 13] }
	];
	var columnChartData = [
		{ name: 'Net Profit', data: [44, 55, 57, 56, 61, 58, 63, 60, 66] }, 
		{ name: 'Revenue', data: [76, 85, 101, 98, 87, 105, 91, 114, 94] }, 
		{ name: 'Free Cash Flow', data: [35, 41, 36, 26, 45, 48, 52, 53, 41] }
	];
	var areaChartData = [
		{ name: 'series1', data: [31, 40, 28, 51, 42, 109, 100] }, 
		{ name: 'series2', data: [11, 32, 45, 32, 34, 52, 41] }
	];
	var barChartData = [
		{ data: [44, 55, 41, 64, 22, 43, 21] },
		{ data: [53, 32, 33, 52, 13, 44, 32] }
	];
	var mixedChartData = [
		{ name: 'Income', type: 'column', data: [1.4, 2, 2.5, 1.5, 2.5, 2.8, 3.8, 4.6] }, 
		{ name: 'Cashflow', type: 'column',	data: [1.1, 3, 3.1, 4, 4.1, 4.9, 6.5, 8.5] },
		{ name: 'Revenue', type: 'line', data: [20, 29, 37, 36, 44, 45, 50, 58] }
	];
	var candlestickChartData = [{
		data: [
			{ x: new Date(1538778600000), y: [6629.81, 6650.5, 6623.04, 6633.33] }, { x: new Date(1538780400000), y: [6632.01, 6643.59, 6620, 6630.11] }, { x: new Date(1538782200000), y: [6630.71, 6648.95, 6623.34, 6635.65] }, { x: new Date(1538784000000), y: [6635.65, 6651, 6629.67, 6638.24] }, { x: new Date(1538785800000), y: [6638.24, 6640, 6620, 6624.47] }, { x: new Date(1538787600000), y: [6624.53, 6636.03, 6621.68, 6624.31] }, { x: new Date(1538789400000), y: [6624.61, 6632.2, 6617, 6626.02] }, { x: new Date(1538791200000), y: [6627, 6627.62, 6584.22, 6603.02] }, { x: new Date(1538793000000), y: [6605, 6608.03, 6598.95, 6604.01] }, 
			{ x: new Date(1538794800000), y: [6604.5, 6614.4, 6602.26, 6608.02] }, { x: new Date(1538796600000), y: [6608.02, 6610.68, 6601.99, 6608.91] }, { x: new Date(1538798400000), y: [6608.91, 6618.99, 6608.01, 6612] }, { x: new Date(1538800200000), y: [6612, 6615.13, 6605.09, 6612] }, { x: new Date(1538802000000), y: [6612, 6624.12, 6608.43, 6622.95] }, { x: new Date(1538803800000), y: [6623.91, 6623.91, 6615, 6615.67] }, { x: new Date(1538805600000), y: [6618.69, 6618.74, 6610, 6610.4] }, { x: new Date(1538807400000), y: [6611, 6622.78, 6610.4, 6614.9] }, { x: new Date(1538809200000), y: [6614.9, 6626.2, 6613.33, 6623.45] }, { x: new Date(1538811000000), y: [6623.48, 6627, 6618.38, 6620.35] }, { x: new Date(1538812800000), y: [6619.43, 6620.35, 6610.05, 6615.53] }, { x: new Date(1538814600000), y: [6615.53, 6617.93, 6610, 6615.19] }, { x: new Date(1538816400000), y: [6615.19, 6621.6, 6608.2, 6620] }, { x: new Date(1538818200000), y: [6619.54, 6625.17, 6614.15, 6620] }, 
			{ x: new Date(1538820000000), y: [6620.33, 6634.15, 6617.24, 6624.61] }, { x: new Date(1538821800000), y: [6625.95, 6626, 6611.66, 6617.58] }, { x: new Date(1538823600000), y: [6619, 6625.97, 6595.27, 6598.86] }, { x: new Date(1538825400000), y: [6598.86, 6598.88, 6570, 6587.16] }, { x: new Date(1538827200000), y: [6588.86, 6600, 6580, 6593.4] }, { x: new Date(1538829000000), y: [6593.99, 6598.89, 6585, 6587.81] }, { x: new Date(1538830800000), y: [6587.81, 6592.73, 6567.14, 6578] }, { x: new Date(1538832600000), y: [6578.35, 6581.72, 6567.39, 6579] }, { x: new Date(1538834400000), y: [6579.38, 6580.92, 6566.77, 6575.96] }, { x: new Date(1538836200000), y: [6575.96, 6589, 6571.77, 6588.92] }, { x: new Date(1538838000000), y: [6588.92, 6594, 6577.55, 6589.22] }, { x: new Date(1538839800000), y: [6589.3, 6598.89, 6589.1, 6596.08] }, { x: new Date(1538841600000), y: [6597.5, 6600, 6588.39, 6596.25] }, { x: new Date(1538843400000), y: [6598.03, 6600, 6588.73, 6595.97] }, 
			{ x: new Date(1538845200000), y: [6595.97, 6602.01, 6588.17, 6602] }, { x: new Date(1538847000000), y: [6602, 6607, 6596.51, 6599.95] }, { x: new Date(1538848800000), y: [6600.63, 6601.21, 6590.39, 6591.02] }, { x: new Date(1538850600000), y: [6591.02, 6603.08, 6591, 6591] }, { x: new Date(1538852400000), y: [6591, 6601.32, 6585, 6592] }, { x: new Date(1538854200000), y: [6593.13, 6596.01, 6590, 6593.34] }, { x: new Date(1538856000000), y: [6593.34, 6604.76, 6582.63, 6593.86] }, { x: new Date(1538857800000), y: [6593.86, 6604.28, 6586.57, 6600.01] }, { x: new Date(1538859600000), y: [6601.81, 6603.21, 6592.78, 6596.25] }, { x: new Date(1538861400000), y: [6596.25, 6604.2, 6590, 6602.99] }, { x: new Date(1538863200000), y: [6602.99, 6606, 6584.99, 6587.81] }, { x: new Date(1538865000000), y: [6587.81, 6595, 6583.27, 6591.96] }, { x: new Date(1538866800000), y: [6591.97, 6596.07, 6585, 6588.39] }, { x: new Date(1538868600000), y: [6587.6, 6598.21, 6587.6, 6594.27] }, { x: new Date(1538870400000), y: [6596.44, 6601, 6590, 6596.55] }, 
			{ x: new Date(1538872200000), y: [6598.91, 6605, 6596.61, 6600.02] }, { x: new Date(1538874000000), y: [6600.55, 6605, 6589.14, 6593.01] }, { x: new Date(1538875800000), y: [6593.15, 6605, 6592, 6603.06] }, { x: new Date(1538877600000), y: [6603.07, 6604.5, 6599.09, 6603.89] }, { x: new Date(1538879400000), y: [6604.44, 6604.44, 6600, 6603.5] }, { x: new Date(1538881200000), y: [6603.5, 6603.99, 6597.5, 6603.86] }, { x: new Date(1538883000000), y: [6603.85, 6605, 6600, 6604.07] }, { x: new Date(1538884800000), y: [6604.98, 6606, 6604.07, 6606]
		}]
	}];
	var bubbleChartData = [
		{ name: 'Bubble1', data: generateBubbleChartData(new Date('11 Feb 2026 GMT').getTime(), 20, { min: 10, max: 60 }) },
		{	name: 'Bubble2', data: generateBubbleChartData(new Date('11 Feb 2026 GMT').getTime(), 20, { min: 10, max: 60 }) },
		{ name: 'Bubble3', data: generateBubbleChartData(new Date('11 Feb 2026 GMT').getTime(), 20, { min: 10, max: 60 }) },
		{ name: 'Bubble4', data: generateBubbleChartData(new Date('11 Feb 2026 GMT').getTime(), 20, { min: 10, max: 60 }) }
	];
	var scatterChartData = [
		{ name: "SAMPLE A", data: [[16.4, 5.4],[21.7, 2],[25.4, 3],[19, 2],[10.9, 1],[13.6, 3.2],[10.9, 7.4],[10.9, 0],[10.9, 8.2],[16.4, 0],[16.4, 1.8],[13.6, 0.3],[13.6, 0],[29.9, 0],[27.1, 2.3],[16.4, 0],[13.6, 3.7],[10.9, 5.2],[16.4, 6.5],[10.9, 0],[24.5, 7.1],[10.9, 0],[8.1, 4.7],[19, 0],[21.7, 1.8],[27.1, 0],[24.5, 0],[27.1, 0],[29.9, 1.5],[27.1, 0.8],[22.1, 2]] }, 
		{ name: "SAMPLE B", data: [[36.4, 13.4],[1.7, 11],[5.4, 8],[9, 17],[1.9, 4],[3.6, 12.2],[1.9, 14.4],[1.9, 9],[1.9, 13.2],[1.4, 7],[6.4, 8.8],[3.6, 4.3],[1.6, 10],[9.9, 2],[7.1, 15],[1.4, 0],[3.6, 13.7],[1.9, 15.2],[6.4, 16.5],[0.9, 10],[4.5, 17.1],[10.9, 10],[0.1, 14.7],[9, 10],[12.7, 11.8],[2.1, 10],[2.5, 10],[27.1, 10],[2.9, 11.5],[7.1, 10.8],[2.1, 12]] }, 
		{ name: "SAMPLE C", data: [[21.7, 3],[23.6, 3.5],[24.6, 3],[29.9, 3],[21.7, 20],[23, 2],[10.9, 3],[28, 4],[27.1, 0.3],[16.4, 4],[13.6, 0],[19, 5],[22.4, 3],[24.5, 3],[32.6, 3],[27.1, 4],[29.6, 6],[31.6, 8],[21.6, 5],[20.9, 4],[22.4, 0],[32.6, 10.3],[29.7, 20.8],[24.5, 0.8],[21.4, 0],[21.7, 6.9],[28.6, 7.7],[15.4, 0],[18.1, 0],[33.4, 0],[16.4, 0]] }
	];
	var heatmapChartData = [
		{ name: 'Metric1', data: generateHeatmapData(18, {	min: 0, max: 90 }) }, 
		{ name: 'Metric2', data: generateHeatmapData(18, {	min: 0, max: 90 }) }, 
		{ name: 'Metric3', data: generateHeatmapData(18, {	min: 0, max: 90 }) }, 
		{ name: 'Metric4', data: generateHeatmapData(18, {	min: 0, max: 90 }) }, 
		{ name: 'Metric5', data: generateHeatmapData(18, {	min: 0, max: 90 }) }, 
		{ name: 'Metric6', data: generateHeatmapData(18, {	min: 0, max: 90 }) }, 
		{ name: 'Metric7', data: generateHeatmapData(18, {	min: 0, max: 90 }) }, 
		{ name: 'Metric8', data: generateHeatmapData(18, {	min: 0, max: 90 }) }, 
		{ name: 'Metric9', data: generateHeatmapData(18, {	min: 0, max: 90 }) }
	];
	var pieChartData = [44, 55, 13, 43, 22];
	var radialBarChartData = [76, 67, 61, 90];
	var radarChartData = [
		{ name: 'Series 1', data: [20, 100, 40, 30, 50, 80, 33] }
	];
	
	function getLineChartOptions() {
		var theme = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
		var white = (getComputedStyle(document.body).getPropertyValue('--bs-white')).trim();
		
		var chartOptions = getChartApexDefaultOptions();
		chartOptions.chart = { toolbar: { show: false } };
		chartOptions.title.text = 'Average High & Low Temperature';
		chartOptions.title.align = 'center';
		chartOptions.colors = [theme, white];
		chartOptions.dataLabels.enabled = true;
		chartOptions.dataLabels.offsetY = 1;
		chartOptions.dataLabels.background = { foreColor: '#000', enabled: true, padding: 3.5, borderRadius: 0, borderWidth: 0, opacity: 1, dropShadow: { enabled: false } };
		chartOptions.stroke = { curve: 'smooth', width: 3 };
		chartOptions.grid.row = { colors: [white, 'transparent'], opacity: 0.15 };
		chartOptions.markers = { size: 4 };
		chartOptions.xaxis.categories = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'];
		chartOptions.yaxis.min = 5;
		chartOptions.yaxis.max = 40;
		chartOptions.legend.show = true;
		chartOptions.legend.position = 'top';
		chartOptions.legend.offsetY = -10;
		chartOptions.legend.horizontalAlign = 'right';
		chartOptions.legend.floating = true;
		
		return chartOptions;
	}
	
	function getColumnChartOptions() {
		var bodyFontFamily = (getComputedStyle(document.body).getPropertyValue('--bs-body-font-family')).trim();
		var bodyFontWeight = (getComputedStyle(document.body).getPropertyValue('--bs-body-font-weight')).trim();
		var bodyColorRgb = (getComputedStyle(document.body).getPropertyValue('--bs-body-color-rgb')).trim();
		var theme = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
		var gray500 = (getComputedStyle(document.body).getPropertyValue('--bs-gray-500')).trim();
		var white = (getComputedStyle(document.body).getPropertyValue('--bs-white')).trim();
		
		var chartOptions = getChartApexDefaultOptions();
	
		chartOptions.title.text = 'Profit & Margin Chart';
		chartOptions.title.align = 'center';
		chartOptions.plotOptions = { bar: { horizontal: false, columnWidth: '55%', endingShape: 'rounded' } };
		chartOptions.dataLabels.enabled = false;
		chartOptions.stroke = {
			show: true,
			width: 2,
			colors: ['transparent']
		};
		chartOptions.colors = [theme, gray500, white];
		chartOptions.xaxis.categories = ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'];
		chartOptions.yaxis.title = {
			text: '$ (thousands)',
			style: { color: 'rgba('+ bodyColorRgb + ', .5)', fontSize: '12px', fontFamily: bodyFontFamily, fontWeight: bodyFontWeight }
		};
		chartOptions.fill = { opacity: 1 };
		chartOptions.tooltip = {
			y: {
				formatter: function (val) { return "$ " + val + " thousands" }
			}
		};
		
		return chartOptions;
	}
	
	function getAreaChartOptions() {
		var theme = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
		var white = (getComputedStyle(document.body).getPropertyValue('--bs-white')).trim();
		var borderColor = (getComputedStyle(document.body).getPropertyValue('--bs-border-color')).trim();
		
		var chartOptions = getChartApexDefaultOptions();
		
		chartOptions.dataLabels = { enabled: false };
		chartOptions.stroke = { curve: 'smooth', width: 2 };
		chartOptions.colors = [theme, white];
		chartOptions.xaxis.type = 'datetime';
		chartOptions.xaxis.categories = ['2026-09-19T00:00:00', '2026-09-19T01:30:00', '2026-09-19T02:30:00', '2026-09-19T03:30:00', '2026-09-19T04:30:00', '2026-09-19T05:30:00', '2026-09-19T06:30:00'];
		chartOptions.xaxis.axisBorder = {
			show: true,
			color: borderColor,
			height: 1,
			width: '100%',
			offsetX: 0,
			offsetY: -1
		};
		chartOptions.xaxis.axisTicks = {
			show: true,
			borderType: 'solid',
			color: borderColor,
			height: 6,
			offsetX: 0,
			offsetY: 0
		};
		chartOptions.tooltip = { x: { format: 'dd/MM/yy HH:mm' } };
		
		return chartOptions;
	}
	
	function getBarChartOptions() {
		var theme = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
		var white = (getComputedStyle(document.body).getPropertyValue('--bs-white')).trim();
		var black = (getComputedStyle(document.body).getPropertyValue('--bs-black')).trim();
		var borderColor = (getComputedStyle(document.body).getPropertyValue('--bs-border-color')).trim();
		
		var chartOptions = getChartApexDefaultOptions();
		
		chartOptions.dataLabels = { enabled: false };
		chartOptions.plotOptions = {
			bar: {
				horizontal: true,
				dataLabels: { position: 'top' }
			}  
		};
		chartOptions.dataLabels = {
			enabled: true,
			offsetX: -6,
			style: {
				fontSize: '10px',
				fontWeight: 500,
				colors: [black]
			}
		};
		chartOptions.colors = [theme, white];
		chartOptions.stroke = { show: false };
		chartOptions.xaxis.categories = [2013, 2014, 2015, 2016, 2017, 2018, 2019];
		chartOptions.xaxis.axisBorder = {
			show: true,
			color: borderColor,
			height: 1,
			width: '100%',
			offsetX: 0,
			offsetY: -1
		};
		chartOptions.xaxis.axisTicks = {
			show: true,
			borderType: 'solid',
			color: borderColor,
			height: 6,
			offsetX: 0,
			offsetY: 0
		};
		
		return chartOptions;
	}
	
	function getMixedChartOptions() {
		var theme = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
		var warning = (getComputedStyle(document.body).getPropertyValue('--bs-warning')).trim();
		var bodyColor = (getComputedStyle(document.body).getPropertyValue('--bs-body-color')).trim();
		var bodyColorRgb = (getComputedStyle(document.body).getPropertyValue('--bs-body-color-rgb')).trim();
		var borderColor = (getComputedStyle(document.body).getPropertyValue('--bs-border-color')).trim();
		
		var chartOptions = getChartApexDefaultOptions();
		
		chartOptions.chart = { stacked: false };
		chartOptions.dataLabels = { enabled: false };
		chartOptions.stroke = { width: [0, 0, 3] };
		chartOptions.colors = [theme, 'rgba('+ bodyColorRgb + ', .5)', warning];
		chartOptions.title.text = 'XYZ - Stock Analysis (2015 - 2026)';
		chartOptions.title.align = 'left';
		chartOptions.title.offsetX = 110;
		chartOptions.xaxis = {
			categories: [2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026],
			axisBorder: {
				show: true,
				color: borderColor,
				height: 1,
				width: '100%',
				offsetX: 0,
				offsetY: -1
			},
			axisTicks: {
				show: true,
				borderType: 'solid',
				color: borderColor,
				height: 6,
				offsetX: 0,
				offsetY: 0
			}
		};
		chartOptions.yaxis = [{
			axisTicks: { show: true, color: borderColor },
			axisBorder: { show: true, color: theme },
			labels: { style: { colors: [bodyColor] } },
			title: {
				text: "Income (*1000)",
				style: { color: theme }
			},
			tooltip: { enabled: true }
		},{
			seriesName: 'Income',
			opposite: true,
			axisTicks: { show: true, color: borderColor },
			axisBorder: { show: true, color: borderColor },
			labels: { style: { colors: [bodyColor] } },
			title: {
				text: "Operating Cashflow (*1000)",
				style: { color: bodyColor }
			},
		}, {
			seriesName: 'Revenue',
			opposite: true,
			axisTicks: { show: true, color: borderColor },
			axisBorder: { show: true, color: warning },
			labels: { style: { colors: [bodyColor] } },
			title: {
				text: "Revenue (*1000)",
				style: { color: warning }
			}
		}];
		chartOptions.tooltip = {
			fixed: {
				enabled: true,
				position: 'topLeft',
				offsetY: 30,
				offsetX: 60
			},
		};
		chartOptions.legend.horizontalAlign = 'left';
		chartOptions.legend.offsetX = 40;
		
		return chartOptions;
	}
	
	function getCandlestickChartOptions() {
		var success = (getComputedStyle(document.body).getPropertyValue('--bs-success')).trim();
		var danger = (getComputedStyle(document.body).getPropertyValue('--bs-danger')).trim();
		var borderColor = (getComputedStyle(document.body).getPropertyValue('--bs-border-color')).trim();
		
		var chartOptions = getChartApexDefaultOptions();
		
		chartOptions.plotOptions = {
			candlestick: {
				colors: {
					upward: success,
					downward: danger
				},
				wick: { useFillColor: true }
			}
		};
		chartOptions.title.text = 'CandleStick Chart';
		chartOptions.title.align = 'left';
		chartOptions.xaxis.type = 'datetime';
		chartOptions.xaxis.axisBorder = {
			show: true,
			color: borderColor,
			height: 1,
			width: '100%',
			offsetX: 0,
			offsetY: -1
		};
		chartOptions.xaxis.axisTicks = {
			show: true,
			borderType: 'solid',
			color: borderColor,
			height: 6,
			offsetX: 0,
			offsetY: 0
		};
		chartOptions.yaxis.tooltip = { enabled: true };
		
		return chartOptions;
	}
	
	function getBubbleChartOptions() {
		var theme = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
		var white = (getComputedStyle(document.body).getPropertyValue('--bs-white')).trim();
		var pink = (getComputedStyle(document.body).getPropertyValue('--bs-pink')).trim();
		var bodyColorRgb = (getComputedStyle(document.body).getPropertyValue('--bs-body-color-rgb')).trim();
		
		var chartOptions = getChartApexDefaultOptions();
		
		chartOptions.markers = { strokeColors: 'transparent' };
		chartOptions.dataLabels = { enabled: false };
		chartOptions.colors = [theme, white, 'rgba('+ bodyColorRgb + ', .5)', pink];
		chartOptions.fill = { opacity: 0.8 };
		chartOptions.title = { text: 'Simple Bubble Chart' };
		chartOptions.xaxis.tickAmount = 12;
		chartOptions.xaxis.type = 'category';
		chartOptions.yaxis.max = 70;
		
		return chartOptions;
	}
	
	function getScatterChartOptions() {
		var theme = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
		var warning = (getComputedStyle(document.body).getPropertyValue('--bs-warning')).trim();
		var bodyColorRgb = (getComputedStyle(document.body).getPropertyValue('--bs-body-color-rgb')).trim();
		
		var chartOptions = getChartApexDefaultOptions();
		
		chartOptions.chart = { zoom: { enabled: true, type: 'xy' } };
		chartOptions.colors = [theme, warning, 'rgba('+ bodyColorRgb + ', .5)'];
		chartOptions.markers = { strokeColors: 'transparent' };
		chartOptions.xaxis.tickAmount = 10;
		chartOptions.xaxis.labels = {
			formatter: function(val) { return parseFloat(val).toFixed(1) }
		};
		
		return chartOptions;
	}
	
	function getHeatmapChartOptions() {
		var theme = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
		var gray900 = (getComputedStyle(document.body).getPropertyValue('--bs-gray-900')).trim();
		
		var chartOptions = getChartApexDefaultOptions();
		
		chartOptions.dataLabels = { enabled: false };
		chartOptions.colors = [theme];
		chartOptions.plotOptions = { heatmap: { radius: 0 } };
		chartOptions.stroke = { show: true, colors: [gray900], width: 2, dashArray: 0 };
		chartOptions.title.text = 'HeatMap Chart (Single color)';
		
		return chartOptions;
	}
	
	function getPieChartOptions() {
		var themeRgb = (getComputedStyle(document.body).getPropertyValue('--bs-theme-rgb')).trim();
		var whiteRgb = (getComputedStyle(document.body).getPropertyValue('--bs-white-rgb')).trim();
		
		var chartOptions = getChartApexDefaultOptions();
		
		chartOptions.dataLabels = { dropShadow: { enabled: false } };
		chartOptions.stroke = { show: false };
		chartOptions.colors = [ 'rgba('+ whiteRgb +', .5)',  'rgba('+ themeRgb +', .25)',  'rgba('+themeRgb +', .5)', 'rgba('+ themeRgb + ', .15)',  'rgba('+whiteRgb +', .25)'];
		chartOptions.labels = ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'];
		chartOptions.title.text = 'HeatMap Chart (Single color)';
		
		return chartOptions;
	}
	
	function getRadialBarChartOptions() {
		var theme = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
		var themeRgb = (getComputedStyle(document.body).getPropertyValue('--bs-theme-rgb')).trim();
		var whiteRgb = (getComputedStyle(document.body).getPropertyValue('--bs-white-rgb')).trim();
		var borderColor = (getComputedStyle(document.body).getPropertyValue('--bs-border-color')).trim();
		
		var chartOptions = getChartApexDefaultOptions();
		
		chartOptions.plotOptions = {
			radialBar: {
				offsetY: 0,
				startAngle: 0,
				endAngle: 270,
				hollow: { margin: 5, size: '30%', background: 'transparent', image: undefined },
				track: { background: borderColor },
				dataLabels: {
					name: { show: false },
					value: { show: false }
				}
			}
		};
		chartOptions.colors = [theme, 'rgba('+ themeRgb + ', .5)', 'rgba('+ themeRgb + ', .25)', 'rgba('+ whiteRgb + ', .25)'];
		chartOptions.labels = ['Vimeo', 'Messenger', 'Facebook', 'LinkedIn'];
		chartOptions.legend = {
			show: true,
			floating: true,
			position: 'left',
			labels: { useSeriesColors: true },
			markers: { size: 0 },
			formatter: function(seriesName, opts) {
				return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex]
			},
			itemMargin: { horizontal: 1 }
		};
		
		return chartOptions;
	}
	
	function getRadarChartOptions() {
		var theme = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
		var whiteRgb = (getComputedStyle(document.body).getPropertyValue('--bs-white-rgb')).trim();
		
		var chartOptions = getChartApexDefaultOptions();
		
		chartOptions.labels = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		chartOptions.plotOptions = {
			radar: {
				size: 140,
				polygons: {
					strokeColors: 'rgba('+ whiteRgb +', .25)',
					strokeWidth: 1,
					connectorColors: 'rgba('+ whiteRgb +', .25)',
					fill: { colors: ['rgba('+ whiteRgb +', .05)', 'rgba('+ whiteRgb +', .1)'] }
				}
			}
		};
		chartOptions.title.text = 'Radar with Polygon Fill';
		chartOptions.colors = [theme];
		chartOptions.markers = { size: 4, colors: [theme], strokeColor: theme, strokeWidth: 2 };
		chartOptions.tooltip = { y: { formatter: function(val) { return val } } };
		chartOptions.yaxis.tickAmount = 7;
		
		return chartOptions;
	}
	
	function setChartOptionsState() {
		setLineChartOptions(getLineChartOptions());
		setColumnChartOptions(getColumnChartOptions());
		setAreaChartOptions(getAreaChartOptions());
		setBarChartOptions(getBarChartOptions());
		setMixedChartOptions(getMixedChartOptions());
		setCandlestickChartOptions(getCandlestickChartOptions());
		setBubbleChartOptions(getBubbleChartOptions());
		setScatterChartOptions(getScatterChartOptions());
		setHeatmapChartOptions(getHeatmapChartOptions());
		setPieChartOptions(getPieChartOptions());
		setRadialBarChartOptions(getRadialBarChartOptions());
		setRadarChartOptions(getRadarChartOptions());
	}
	
	useEffect(() => {
		fetch('/quantum-react/assets/data/chart/apexchart-code-1.json').then(function(response) { return response.text(); }).then((html) => { setCode1(html); });
		fetch('/quantum-react/assets/data/chart/apexchart-code-2.json').then(function(response) { return response.text(); }).then((html) => { setCode2(html); });
		fetch('/quantum-react/assets/data/chart/apexchart-code-3.json').then(function(response) { return response.text(); }).then((html) => { setCode3(html); });
		fetch('/quantum-react/assets/data/chart/apexchart-code-4.json').then(function(response) { return response.text(); }).then((html) => { setCode4(html); });
		fetch('/quantum-react/assets/data/chart/apexchart-code-5.json').then(function(response) { return response.text(); }).then((html) => { setCode5(html); });
		fetch('/quantum-react/assets/data/chart/apexchart-code-6.json').then(function(response) { return response.text(); }).then((html) => { setCode6(html); });
		fetch('/quantum-react/assets/data/chart/apexchart-code-7.json').then(function(response) { return response.text(); }).then((html) => { setCode7(html); });
		fetch('/quantum-react/assets/data/chart/apexchart-code-8.json').then(function(response) { return response.text(); }).then((html) => { setCode8(html); });
		fetch('/quantum-react/assets/data/chart/apexchart-code-9.json').then(function(response) { return response.text(); }).then((html) => { setCode9(html); });
		fetch('/quantum-react/assets/data/chart/apexchart-code-10.json').then(function(response) { return response.text(); }).then((html) => { setCode10(html); });
		fetch('/quantum-react/assets/data/chart/apexchart-code-11.json').then(function(response) { return response.text(); }).then((html) => { setCode11(html); });
		fetch('/quantum-react/assets/data/chart/apexchart-code-12.json').then(function(response) { return response.text(); }).then((html) => { setCode12(html); });
		
		setChartOptionsState();
		
		document.addEventListener('theme-reload', () => {
			setChartOptionsState();
		});
		
		// eslint-disable-next-line
	}, []);
	
	return (
		<div className="container">
			<div className="row justify-content-center">
				<div className="col-xl-10">
					<div className="row">
						<div className="col-xl-9">
							<ul className="breadcrumb">
								<li className="breadcrumb-item"><a href="#/">CHARTS</a></li>
								<li className="breadcrumb-item active">APEXCHARTS.JS</li>
							</ul>
							
							<h1 className="page-header">
								Apexcharts.js <small>page header description goes here...</small>
							</h1>
							
							<hr className="mb-4" />
							
							<div id="apexChart">
								<h4>Basic Example</h4>
								<p>Apexcharts.js is a modern javaScript charting library to build interactive charts and visualizations with simple API. Please read the <a href="https://apexcharts.com/" target="_blank" rel="noreferrer">official documentation</a> for the full list of options.</p>
							</div>
							
							<div id="apexChartLineChart" className="mb-5">
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<h6 className="mb-3">LINE CHART</h6>
										<div className="ms-n3 mb-n3"><Chart type="line" options={lineChartOptions} series={lineChartData} height="250" /></div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code1}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="apexChartColumnChart" className="mb-5">
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<h6 className="mb-3">COLUMN CHART</h6>
										<div className="mb-n3">
											<Chart type="bar" options={columnChartOptions} series={columnChartData} height="250" />
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code2}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="apexChartAreaChart" className="mb-5">
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<h6 className="mb-3">AREA CHART</h6>
										<div className="mb-n3 ms-n3">
											<Chart type="area" options={areaChartOptions} series={areaChartData} height="250" />
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code3}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="apexChartBarChart" className="mb-5">
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<h6 className="mb-3">BAR CHART</h6>
										<Chart type="bar" options={barChartOptions} series={barChartData} height="250" />
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code4}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="apexChartMixedChart" className="mb-5">
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<h6 className="mb-3">MIXED CHART</h6>
										<div className="ms-n3">
											<Chart type="line" options={mixedChartOptions} series={mixedChartData} height="250" />
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code5}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="apexChartCandlestickChart" className="mb-5">
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<h6 className="mb-3">CANDLESTICK CHART</h6>
										<Chart type="candlestick" options={candlestickChartOptions} series={candlestickChartData} height="250" />
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code6}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="apexChartBubbleChart" className="mb-5">
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<h6 className="mb-3">BUBBLE CHART</h6>
										<Chart type="bubble" options={bubbleChartOptions} series={bubbleChartData} height="250" />
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code7}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="apexChartScatterChart" className="mb-5">
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<h6 className="mb-3">SCATTER CHART</h6>
										<Chart type="scatter" options={scatterChartOptions} series={scatterChartData} height="250" />
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code8}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="apexChartHeatmapChart" className="mb-5">
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<h6 className="mb-3">HEATMAP CHART</h6>
										<Chart type="heatmap" options={heatmapChartOptions} series={heatmapChartData} height="250" />
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code9}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="apexChartPieChart" className="mb-5">
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<h6 className="mb-3">PIE CHART</h6>
										<Chart type="pie" options={pieChartOptions} series={pieChartData} height="250" />
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code10}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="apexChartRadialBarChart" className="mb-5">
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<h6 className="mb-3">RADIAL BAR CHART</h6>
										<Chart type="radialBar" options={radialBarChartOptions} series={radialBarChartData} height="250" />
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code11}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="apexChartRadarChart" className="mb-5">
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<h6 className="mb-3">RADAR CHART</h6>
										<Chart type="radar" options={radarChartOptions} series={radarChartData} height="350" />
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code12}</Highlight>
									</div>
								</Card>
							</div>
						</div>
						
						<div className="col-xl-3">
							<NavScrollTo>
								<nav className="nav">
									<a className="nav-link" href="#apexChart" data-toggle="scroll-to">Apexcharts.js</a>
									<a className="nav-link" href="#apexChartLineChart" data-toggle="scroll-to"> - line chart</a>
									<a className="nav-link" href="#apexChartColumnChart" data-toggle="scroll-to"> - column chart</a>
									<a className="nav-link" href="#apexChartAreaChart" data-toggle="scroll-to"> - area chart</a>
									<a className="nav-link" href="#apexChartBarChart" data-toggle="scroll-to"> - bar chart</a>
									<a className="nav-link" href="#apexChartMixedChart" data-toggle="scroll-to"> - mixed chart</a>
									<a className="nav-link" href="#apexChartCandlestickChart" data-toggle="scroll-to"> - candlestick chart</a>
									<a className="nav-link" href="#apexChartBubbleChart" data-toggle="scroll-to"> - bubble chart</a>
									<a className="nav-link" href="#apexChartScatterChart" data-toggle="scroll-to"> - scatter chart</a>
									<a className="nav-link" href="#apexChartHeatmapChart" data-toggle="scroll-to"> - heatmap chart</a>
									<a className="nav-link" href="#apexChartPieChart" data-toggle="scroll-to"> - pie chart</a>
									<a className="nav-link" href="#apexChartRadialBarChart" data-toggle="scroll-to"> - radial bar chart</a>
									<a className="nav-link" href="#apexChartRadarChart" data-toggle="scroll-to"> - radar chart</a>
								</nav>
							</NavScrollTo>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ChartApex;